var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HeaderMenuButton } from './menulist/HeaderMenuButton';
import { HeaderMenuIconButton } from './menulist/HeaderMenuIconButton';
import style from './AccountFavoriteButton.module.scss';
import { HeaderPrimaryButton } from './buttons/HeaderPrimaryButton';
import { HeaderMenuList, HeaderMenuListItem } from './menulist/HeaderMenuList';
import { useAperzaUserContext } from './AperzaUserContext';
import AppService from '../utils/AppService';
import { addUtmParam } from '../utils/addUtmParam';
export var headerFavoriteMenuItems = [
    {
        title: 'クリップ一覧',
        url: "".concat(AppService.accountServerHost(), "/clip"),
    },
    {
        title: 'ダウンロード履歴',
        url: "".concat(AppService.accountServerHost(), "/history"),
    },
    {
        title: 'アペルザTV視聴リスト',
        url: "".concat(AppService.tvServerHost(), "/mypage/watchlist"),
    },
    {
        title: 'スキャン de カタログ一覧',
        url: "".concat(AppService.accountServerHost(), "/exhibition/contents/index.html"),
    },
];
export default function AccountFavoriteButton() {
    var _a = useAperzaUserContext(), isLogin = _a.isLogin, serviceType = _a.serviceType, signUpUrl = _a.signUpUrl;
    return (_jsxs(HeaderMenuButton, __assign({ type: "accountDropdown", header: "\u304A\u6C17\u306B\u5165\u308A", button: function (isActive) { return (_jsx(HeaderMenuIconButton, { isActive: isActive, label: "\u304A\u6C17\u306B\u5165\u308A", icon: "".concat(AppService.staticServerHost(), "/common/images/header/star.svg"), iconHover: "".concat(AppService.staticServerHost(), "/common/images/header/star_red.svg") })); }, footer: !isLogin && (_jsx(HeaderPrimaryButton, __assign({ buttonClassName: style.signUpButton, href: addUtmParam(signUpUrl(), 'header', serviceType), outlined: true }, { children: "\u30A2\u30DA\u30EB\u30B6\u4F1A\u54E1\u767B\u9332\uFF08\u7121\u6599\uFF09" }))) }, { children: [!isLogin && (_jsx("div", __assign({ className: style.bodyWrapper }, { children: "\u304A\u6C17\u306B\u5165\u308A\u6A5F\u80FD\u3092\u5229\u7528\u3059\u308B\u306B\u306F\u30ED\u30B0\u30A4\u30F3\u304C\u5FC5\u8981\u3067\u3059\u3002\u30A2\u30DA\u30EB\u30B6ID\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u304A\u5BA2\u69D8\u306F\u4EE5\u4E0B\u3088\u308A\u767B\u9332\u9858\u3044\u307E\u3059\u3002" }))), isLogin && (_jsx(HeaderMenuList, __assign({ bordered: true }, { children: headerFavoriteMenuItems.map(function (item) { return (_jsx(HeaderMenuListItem, { item: item }, "".concat(item.title))); }) })))] })));
}
